import React, { useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import DisabledImage from "../../../../src/Resources/Images/disable.png";
import ActiveImage from "../../../../src/Resources/Images/ActiveImage.png";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Input from "@mui/material/Input";
import InputAdornment from "@mui/material/InputAdornment";
import { visuallyHidden } from "@mui/utils";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import AddLinkBookingCode from "./AddLinkBookingCode";
import ConfirmBox from "../../../UiComponents/ConfirmBox/ConfirmBox";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Switch from "@mui/material/Switch";
import DeleteImage from "../../../../src/Resources/Images/delete_common.png";
import {
  AddIcon,
  SearchIcon,
  NotInterestedIcon,
  DoneOutlineIcon,
  CloudOffIcon,
  DeleteIcon,
  RemoveRedEyeIcon,
} from "../../../Resources/Icons/icons";
import {
  GetLinkBookingCode,
  DeleteLinkBookingCode,
  FilterLinkBookingCode,
  UpdateLinkBookingCode,
  GetBookingCode,
} from "../../../Service/_index";
import axios from "axios";
import moment from "moment";
import Dialog from "@mui/material/Dialog";
import { Transition } from "../../../UiComponents/Transition/Transition";
import { Divider } from "@mui/material";
import TabFilter from "../../../Components/Tabs/Tabs";
import MasterCommonTable from "../../../UiComponents/CommonTable/MasterCommonTable";

function stableSort(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis?.map((el) => el[0]);
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const FilterOption = [
  {
    label: "All Data",
    isEnabled: "all",
    value: 1,
  },
  {
    label: "ActiveData",
    isEnabled: "true",
    value: 2,
  },
  {
    label: "In ActiveData",
    isEnabled: "false",
    value: 3,
  },
];

const getClassName = (data) => {
  return data.status == "Active"
    ? "Active-chip"
    : data.status == "Inactive"
      ? " inActive-chip"
      : "";
};

const headCells = [
  {
    id: "companyName",
    placeMent: true,
    disablePadding: false,
    label: "Company Name",
  },
  {
    id: "bookingCode",
    placeMent: true,
    disablePadding: false,
    label: "Booking Code",
  },
  {
    id: "createdAt",
    placeMent: true,
    disablePadding: false,
    label: "Created Date",
  },
  {
    id: "updatedAt",
    placeMent: true,
    disablePadding: false,
    label: "Updated Date",
  },
  {
    id: "status",
    placeMent: true,
    disablePadding: false,
    label: "Status",
    class: getClassName,
  },
  // {
  //   id: "action",
  //   placeMent: false,
  //   disablePadding: false,
  //   label: "Action",
  // },
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells?.map((headCell) => (
          <TableCell
            className="TableHeader"
            key={headCell.id}
            align={headCell.placeMent ? "left" : "center"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{ fontSize: "16px", fontWeight: 600 }}>
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}>
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  // rowCount: PropTypes.number.isRequired,
};

const LinkBookingCode = () => {
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("id");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [selectedData, setSelectedData] = React.useState({});
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [openConfirmBox, setOpenConfirmBox] = React.useState(false);
  const [linkBookingCode, setLinkBookingCode] = React.useState([]);
  const [searchText, setSearchText] = useState("");
  const [openDeleteConfirmBox, setOpenDeleteConfirmBox] = React.useState(false);
  const [activeBoolean, setActiveBoolean] = useState();
  const [pageView, setPageView] = useState(2);
  const [tableConfig, setTableConfig] = useState({ isAction: true, isView: true, isDelete: true, isSearch: true, isSwitch: true, historyEntity: "linkBookingCode", })
  const [selectedTab, setSelectedTab] = useState(1);
  const [formType, setFormType] = useState("");
  const [loading, setLoading] = useState(false);

  const [filter, setFilter] = useState({
    fn: (items) => {
      return items;
    },
  });

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    const selectedOption = FilterOption.find((option) => option.value === newValue);
    FilterLinkBookingCodeFunction(selectedOption);
  };

  const FilteredData = linkBookingCode.filter((el) => {
    console.log("Element:", el);
    return `${el?.bookingCodeId?.bookingCode},${el?.companyName}`
      .toLowerCase()
      .includes(searchText.toLowerCase());
  });

  const visibleRows = React.useMemo(
    () =>
      stableSort(
        filter.fn(linkBookingCode),
        getComparator(order, orderBy)
      )?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage),
    [order, orderBy, page, rowsPerPage, filter, linkBookingCode]
  );

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    page > 0
      ? Math.max(0, (1 + page) * rowsPerPage - linkBookingCode.length)
      : 0;

  const GetData = () => {
    setLoading(true);
    GetLinkBookingCode().then((res) => {
      const configData = res?.data.map((item) => ({
        ...item,
        companyName: item.companyId?.shortName,
        bookingCode: item.bookingCodeId?.bookingCode,
        createdAt: moment(item.createdAt).format("DD/MM/YYYY hh:mm A"),
        updatedAt: moment(item.updatedAt).format("DD/MM/YYYY hh:mm A"),
        status: item.isEnabled ? "Active" : "Inactive",
      }));
      setLinkBookingCode(configData);
      setLoading(false);
    });
  };

  const GetActiveData = () => {
    setLoading(true);
    GetLinkBookingCode().then((res) => {
      const updatedData = res?.data.map((item) => ({
        ...item,
        companyName: item.companyId?.shortName,
        bookingCode: item.bookingCodeId?.bookingCode,
        createdAt: moment(item.createdAt).format("DD/MM/YYYY hh:mm A"),
        updatedAt: moment(item.updatedAt).format("DD/MM/YYYY hh:mm A"),
        status: item.isEnabled ? "Active" : "Inactive",
      }));
      setLinkBookingCode(updatedData);
      setLoading(false);
    });
  };
  const GetInActiveData = () => {
    setLoading(true);
    GetLinkBookingCode().then((res) => {
      const updatedData = res?.data.map((item) => ({
        ...item,
        companyName: item.companyId?.shortName,
        bookingCode: item.bookingCodeId?.bookingCode,
        createdAt: moment(item.createdAt).format("DD/MM/YYYY hh:mm A"),
        updatedAt: moment(item.updatedAt).format("DD/MM/YYYY hh:mm A"),
        status: item.isEnabled ? "Active" : "Inactive",
      }));
      setLinkBookingCode(updatedData);
      setLoading(false);
    });
  };

  React.useEffect(() => {
    GetData();
  }, []);

  const CreateLinkBookingCodeData = () => {
    setSelectedData({});
    setOpenDrawer(true);
    setFormType("add");
  };

  const DeleteLinkBookingCodeData = (row) => {
    setOpenDeleteConfirmBox(true);
    setSelectedData(row);
  };

  const ViewLinkBookingCode = (row) => {
    setSelectedData(row);
    setOpenDrawer(true);
    setFormType("view");
  };
  const DeleteFunction = () => {
    DeleteLinkBookingCode(selectedData._id).then((res) => {
      switch (pageView) {
        case 1:
          GetData();
          break;
        case 2:
          GetActiveData();
          break;
        case 3:
          GetInActiveData();
          break;
        default:
          break;
      }
      setOpenDeleteConfirmBox(false);
    });
  };

  const ActiveBookingCodeData = (row, active) => {
    setOpenConfirmBox(true);
    setSelectedData(row);
    setActiveBoolean(!active);
  };

  const ActiveFunction = () => {
    UpdateLinkBookingCode(selectedData._id, { isEnabled: activeBoolean }).then(
      (res) => {
        switch (pageView) {
          case 1:
            GetData();
            break;
          case 2:
            GetActiveData();
            break;
          case 3:
            GetInActiveData();
            break;
          default:
            break;
        }
      }
    );
    setOpenConfirmBox(false);
  };
  const onSearch = (e) => {
    let target = e.target;
    setFilter({
      fn: (items) => {
        if (target.value == "") return items;
        else
          return items.filter((el) =>
            `${el?.companyId?.shortName},${el?.bookingCodeId?.bookingCode},${el.remarks}`
              .toLowerCase()
              .includes(target.value.toLowerCase())
          );
      },
    });
    setPage(0);
  };

  const FilterLinkBookingCodeFunction = (e) => {
    setPageView(e?.value);
    let data = e?.isEnabled;
    let apiMethod =
      data === "all"
        ? GetData()
        : FilterLinkBookingCode({ isEnabled: data }).then((res) => {
          setLinkBookingCode(res?.data);
          const updatedData = res?.data.map((item) => ({
            ...item,
            companyName: item.companyId?.shortName,
            bookingCode: item.bookingCodeId?.bookingCode,
            createdAt: moment(item.createdAt).format("DD/MM/YYYY hh:mm A"),
            updatedAt: moment(item.updatedAt).format("DD/MM/YYYY hh:mm A"),
            status: item.isEnabled ? "Active" : "Inactive",
          }));
          setLinkBookingCode(updatedData);
        });
    setPage(0)
  };

  return (
    <>
      <Grid container className="Master_Card_Container">
        <Grid container alignItems={"center"} className="Master_Card_Sub_Container">
          <Grid item xs={12} sm={6} md={6}>
            <Typography className="Master_Card_Tittle">
              Link Booking Code
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={6} className="d-flex justify-content-end">
            <Button
              className="Master_Card_create_Button w-100"
              startIcon={<AddIcon sx={{
                marginRight: "1.5px"
              }} />}
              onClick={() => CreateLinkBookingCodeData()}
            >
              Create
            </Button>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Divider sx={{
            backgroundColor: "#EAECF0",
            borderWidth: 1,
          }} />
        </Grid>
        <Grid container alignItems={"center"} justifyContent={"space-between"} className="Master_Card_Sub_Container">
          <TabFilter
            options={FilterOption}
            selectedTab={selectedTab}
            onTabChange={handleTabChange}
          />
          <Grid item xs={12} sm={4} md={3.1} mt={{ xs: 2, sm: 0, md: 0 }}>
            <Input
              focused="false"
              className="w-100 Master_Card_Input"
              id="standard-adornment-password"
              // onChange={onSearch}
              onChange={(e) => {
                setSearchText(e.target.value);
                setPage(0);
              }}
              disableUnderline={true}
              placeholder="Search in LinkBooking Code"
              startAdornment={
                <InputAdornment position="start" sx={{ marginRight: "0px" }}>
                  <IconButton aria-label="toggle password visibility">
                    <SearchIcon sx={{
                      fontSize: "20px"
                    }} />
                  </IconButton>
                </InputAdornment>
              }
            />
          </Grid>
        </Grid>
        <MasterCommonTable
          tableConfig={tableConfig}
          data={FilteredData}
          columns={headCells}
          handleView={ViewLinkBookingCode}
          handleDelete={DeleteLinkBookingCodeData}
          handleApprove={ActiveBookingCodeData}
          tableTotalCount={filter.fn(linkBookingCode)?.length || 0}
          loading={loading}
        />
      </Grid>

      <Dialog
        open={openDrawer}
        TransitionComponent={Transition}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          sx: {
            maxWidth: {
              xs: "80%",
              sm: "70%",
              md: "50%",
              lg: "40%",
            },
          },
        }}
      >
        {openDrawer ? (
          <AddLinkBookingCode
            title={
              formType === "edit"
                ? "Edit"
                : formType === "view"
                  ? "View"
                  : "Create"
            }
            selectedData={selectedData}
            formType={formType}
            setOpenDrawer={setOpenDrawer}
            GetActiveData={GetActiveData}
          />
        ) : null}
      </Dialog>

      <ConfirmBox
        open={openConfirmBox}
        title={selectedData.isEnabled ? "Inactive" : "Active"}
        content={`Are you sure want to ${selectedData.isEnabled ? "Inactive" : "Active"
          }`}
        confirmButton={selectedData.isEnabled ? "Inactive" : "Active"}
        setOpenConfirmBox={setOpenConfirmBox}
        Function={ActiveFunction}
        icon={
          selectedData.isEnabled ? <NotInterestedIcon /> : <DoneOutlineIcon />
        }
        color={selectedData.isEnabled ? "error" : "bule"}
        subContent={
          selectedData.isEnabled
            ? "This action will disable the item, and it won't be accessible until reactivated."
            : "Once activated, this item will be accessible. You can disable it later if needed."
        }
        img={selectedData.isEnabled ? DisabledImage : ActiveImage}
      />
      <ConfirmBox
        open={openDeleteConfirmBox}
        title="Delete"
        content="Are you sure you want to delete this?"
        subContent="This action cannot be undone. Once deleted, the data will be permanently removed from the system."
        img={DeleteImage}
        confirmButton="Delete"
        setOpenConfirmBox={setOpenDeleteConfirmBox}
        Function={DeleteFunction}
        icon={<DeleteIcon />}
        color="error"
      />
    </>
  );
};
export default LinkBookingCode;
